import React from 'react';

const PlanoContaContext = React.createContext();

export default PlanoContaContext;
